const PUMP_ASSET = 'PUMP';
const WATER_TOWER_ASSET = 'WATER_TOWER';
const WET_WELL_ASSET = 'WET_WELL';
const MBR_TRAIN_ASSET = 'MBR_TRAIN';
const VALVE_ASSET = 'VALVE';

export { PUMP_ASSET, WATER_TOWER_ASSET, WET_WELL_ASSET, MBR_TRAIN_ASSET, VALVE_ASSET };
